// removed by extract-text-webpack-plugin
module.exports = {"detail":"style__detail___2toCm6","content":"style__content___2iKEke","fileDetail":"style__fileDetail___hCIOVo","searchList":"style__searchList___13ZJFv"};